import React, { useEffect, useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { LoadingOutlined } from "@ant-design/icons";
import Line from "../../atoms/HorizontalLine";
import CustomCheckBox from "../../atoms/CustomCheckBox";
// import { bidConditions } from "../../../utils/API/bidConditions";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { bidConditions } from "../../../utils/API/bidCondition";

const BidDialogBox = ({
  open,
  onCancel,
  onOk,
  projectId,
  bidLoading,
  // onConditionsAcceptedChange,
  conditions,
}) => {
  // const [conditions, setConditions] = useState("");
  // const dispatch = useDispatch();
  const [isConditionsAccepted, setConditionsAccepted] = useState(false);
  const [error, setError] = useState("");

  const handleCheck = () => {
    setConditionsAccepted(!isConditionsAccepted);
    if (error) setError(""); // Clear error message on checkbox change
  };

  const handleOk = () => {
    if (!isConditionsAccepted) {
      setError("Please accept the conditions to continue.");
      return;
    }
    onOk();
  };

  const handleCancel = () => {
    setConditionsAccepted(false);
    onCancel();
  };

  // useEffect(() => {
  //   fetchConditions();
  // }, [open]);

  // const fetchConditions = async () => {
  //   try {
  //     const response = await bidConditions(projectId, dispatch);
  //     setConditions(response.message);
  //   } catch (error) {
  //     toast.error(error);
  //   }
  // };

  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={539}>
        <div className="py-5 text-[#808080]">
          <h1 className="text-center font-medium text-[15px]">
            Bid Conditions
          </h1>

          <Line />
          <div className="ml-8 mr-4 mt-6 font-medium text-[15px]">
            <ul className=" list-disc font-bold">
              <li className="pb-3">{conditions}</li>
            </ul>
          </div>
          <div className="ml-6 mb-4 text-black">
            <CustomCheckBox
              labelText="I Accept the conditions"
              isChecked={isConditionsAccepted}
              onChange={handleCheck}
            />
          </div>
          {error && <div className="text-red-500 ml-6 mb-4">{error}</div>}
          <div className="flex gap-3 ml-9 mb-3">
            <Button
              varient="primary"
              borderColor="blue"
              className=" w-[14rem] px-9 py-1 text-sm justify-right lg:py-2 text-white font-bold  bg-blue-800   "
              onClick={handleOk}
              disabled={bidLoading}
            >
              {bidLoading ? <LoadingOutlined /> : "Continue"}
            </Button>
            <Button
              varient="primary"
              borderColor="blue"
              className=" w-[14rem] px-9 py-1 text-sm justify-right lg:py-2  border-[1px] border-blue-800 font-bold text-blue-800 bg-blue-100   "
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default BidDialogBox;
